module.exports = __webpack_public_path__ + "media/images/icons/coin-c871794fea4ffa4e0ee477f6f09e3085.svg";